import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './User.css';
import PageTitle from '../Layout/components/PageTitle'
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, TableFooter, TablePagination } from '@material-ui/core';
import UserInfo from './components/UserInfo'
import Search from '@material-ui/icons/Search'
import SideList from './components/SideList'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import Toast from '../Layout/components/Toast';
import { roleName, defaultPageSize, ADD, EDIT, VIEW } from '../../common/common';
import { timeFormat } from '../../common/utils';
import PasswordInfo from './components/PasswordInfo';

const ADMIN = "admin";
class User extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openPwd: false,
            drawerOpen: false,
            dialogTitle: "",
            dialogState: ADD,
            currentObj: null,
            totalUser: [],
            users: [],
            usersCopy: [],
            showToast: false,
            toastMsg: "",
            toastState: "",

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,

            username: "",
            office: "",
            start_salary: 0,
            end_salary: 0,
            sideObj: null,
        }
        this.handleAddUser = this.handleAddUser.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSetting = this.handleSetting.bind(this);
        this.handleChangePwd = this.handleChangePwd.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
    }
    render() {
        const {
            users,
            showToast,
            toastMsg,
            toastState,
            open,
            openPwd,
            drawerOpen,
            dialogTitle,
            currentObj,
            dialogState,
            page_index,
            page_size,
            total_items,
            sideObj,
        } = this.state;
        const operationBtn = (row) => {
            if (roleName === ADMIN) {
                return <div className="h h-l">
                    <Button variant="outlined" size="small" color={row.enabled ? "primary" : "default"} onClick={e => this.handleDisable(e, row)}>{row.enabled ? "Disable" : "Enable"}</Button>
                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                    <Button variant="outlined" size="small" color="primary" onClick={e => this.handleSetting(e, row)}>reset password</Button>
                </div >
            } else {
                return <div className="h h-l">
                    <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                </div>
            }
        }
        const addBtn = () => {
            if (roleName === ADMIN) {
                return <div className="f h h-r">
                    <Button className="btn" variant="contained" color="primary" onClick={this.handleAddUser}>ADD USER</Button>
                </div>
            }
        }
        const thView = (name) => {
            if (roleName === ADMIN) {
                if (name === "hire") {
                    return <TableCell>Hire Date</TableCell>
                } else if (name === "salary") {
                    return <TableCell>Salary</TableCell>
                } else if (name === "username") {
                    return <TableCell>Username</TableCell>
                }
            }
        }
        const tdView = (name, row) => {
            if (roleName === ADMIN) {
                if (name === "hire") {
                    return <TableCell>{timeFormat(row.hire_date)}</TableCell>
                } else if (name === "salary") {
                    return <TableCell>{row.salary || "--"}</TableCell>
                } else if (name === "username") {
                    return <TableCell>{row.username}</TableCell>
                }
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Users" subtitle="MANAGEMENT"></PageTitle>
                    {addBtn()}
                </div>

                <div className="tableTool h h-bt">
                    <div className="search h">
                        <div className="search-icon c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search user"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={this.handleSearch}
                        />
                    </div>
                    <Button className="bgW btn" variant="contained" onClick={e => this.handleDrawer(e, true)}> Show Filters </Button>
                </div>
                <Dialog maxWidth={false} open={open}>
                    <UserInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={currentObj}
                        state={dialogState}
                    ></UserInfo>
                </Dialog>
                <Dialog maxWidth={false} open={openPwd}>
                    <PasswordInfo
                        handleChangePwd={this.handleChangePwd}
                        handleCancel={this.handleCancel}
                    ></PasswordInfo>
                </Dialog>
                <Drawer anchor="right" open={drawerOpen} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                            data={sideObj}
                        ></SideList>
                    </div>
                </Drawer>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                {/* <TableCell>Department</TableCell> */}
                                {thView("username")}
                                <TableCell>First Name</TableCell>
                                <TableCell>Last Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                {/* <TableCell>Office</TableCell> */}
                                {thView("hire")}
                                {thView("salary")}
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    {/* <TableCell>{this.getUserDepartment(row.teams)}</TableCell> */}
                                    {tdView("username", row)}
                                    <TableCell>{row.first_name}</TableCell>
                                    <TableCell>{row.last_name}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.phone}</TableCell>
                                    {/* <TableCell>{row.office}</TableCell> */}
                                    {tdView("hire", row)}
                                    {tdView("salary", row)}
                                    <TableCell>
                                        {operationBtn(row)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {users.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={users.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        this.getUsers();
    }
    getUsers() {
        const { page_index, page_size, username, office, start_salary, end_salary } = this.state;
        let params = {
            username: username ? username : null,
            office: office ? office : null,
            page_index,
            page_size
        }
        if (end_salary > 0) {
            params["start_salary"] = start_salary;
            params["end_salary"] = end_salary;
        }
        if (roleName === ADMIN) {
            this.getAdminUsers(params);
        } else {
            this.getOtherUsers(params);
        }
    }
    handleAddUser() {
        this.openDialog("ADD USER INFO", ADD);
    }
    handleDisable(e, obj) {
        console.log(obj)
        const user_id = obj.id;
        const disabled = obj.enabled;
        this.disabledUser(user_id, !disabled);
    }
    handleView(e, obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog("USER DETAILS", VIEW);
    }
    handleEdit(e, obj) {
        console.log("obj", obj)
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog("EDIT USER", EDIT);
    }
    handleSetting(e, obj) {
        // const user_id = obj.id;
        // const role_id = roleInfo.identity.id;
        this.setState(() => ({
            currentObj: obj
        }))
        this.openPwd();
    }
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleCreate(obj) {
        const { dialogState, currentObj } = this.state;
        if (dialogState === ADD) {
            this.addUser(obj);
        } else if (dialogState === EDIT) {
            this.updateUser(currentObj.id, obj);
        }
    }
    handleChangePwd(pwd) {
        const { currentObj } = this.state;
        this.savePwd(currentObj.id, pwd);
    }
    handleSearch(e) {
        const value = e.target.value;
        // const { usersCopy } = this.state;
        // const arr = this.filterIncludeArr(usersCopy, value);
        // this.setState(() => ({
        //     users: arr
        // }))
        this.setState({
            username: value,
            page_index: 1
            // email: value,
            // phone: value,
            // office: value,
        }, () => {
            this.getUsers();
        })
    }
    handleApply(obj) {
        console.log("filtersList", obj)
        const office = obj.office;
        const start_salary = obj.start_salary;
        const end_salary = obj.end_salary;
        // const department = obj.department;
        // const team = obj.team;
        this.setState({
            page_index: 1,
            drawerOpen: false,
            office,
            start_salary,
            end_salary,
            sideObj: obj
        }, () => {
            this.getUsers();
        })
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleDrawer(e, open) {
        this.setState(() => ({
            drawerOpen: open
        }));
    };
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getUsers();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getUsers();
        });
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            openPwd: false,
            currentObj: null
        }));
    }
    openDialog(title, type) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: type
        }));
    }
    openPwd() {
        this.setState(() => ({
            openPwd: true
        }));
    }
    filterIncludeArr(arr, value) {
        let newArr = [];
        let haveObj = false;
        for (let obj of arr) {
            if (obj.first_name) if (obj.first_name.includes(value)) haveObj = true;
            if (obj.last_name) if (obj.last_name.includes(value)) haveObj = true;
            if (obj.username) if (obj.username.includes(value)) haveObj = true;
            if (obj.id) if (obj.id.toString().includes(value)) haveObj = true;
            if (obj.email) if (obj.email.includes(value)) haveObj = true;
            if (obj.phone) if (obj.phone.includes(value)) haveObj = true;
            if (obj.team) if (obj.team.includes(value)) haveObj = true;
            if (obj.salary) if (obj.salary.includes(value)) haveObj = true;
            if (obj.office) if (obj.office.includes(value)) haveObj = true;
            if (haveObj) {
                newArr.push(obj);
                haveObj = false;
            }
        }
        return newArr;
    }
    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }
    updateRolesList(user_id, arr) {
        console.log(arr)
        if (arr.length > 0) {
            for (const obj of arr) {
                if (obj.check) {
                    this.addRoles(user_id, obj.id);
                } else {
                    this.delRoles(user_id, obj.id);
                }
            }
        } else {
            this.getUsers();
            this.closeDialog();
        }
    }
    //------------request-----------------
    addRoles(user_id, role_id) {
        instance.post(BASE_URL + 'admin/users/' + user_id + '/roles/' + role_id).then((res) => {
            this.getUsers();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delRoles(user_id, role_id) {
        instance.delete(BASE_URL + 'admin/users/' + user_id + '/roles/' + role_id).then((res) => {
            this.getUsers();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addUser(obj) {
        let params = {
            email: obj.email,
            phone: obj.phone,
            username: obj.username,
            password: obj.password,
            first_name: obj.first_name,
            last_name: obj.last_name,
            hire_date: obj.hire_date,
            salary: obj.salary,
            rate: obj.rate,
            office: obj.office,
            position: obj.position,
            members: obj.members
        }
        instance.post(BASE_URL + 'admin/users', params).then((res) => {
            console.log("add", res.data.data)
            const userId = res.data.data.id;
            this.showToast("Added successfully", "success");
            this.updateRolesList(userId, obj.roleData);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    };
    updateUser(user_id, obj) {
        let params = {
            username: obj.username,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            // office: obj.office,
            hire_date: obj.hire_date,//时间戳
            position: obj.position,
            salary: obj.salary,
            rate: obj.rate
        }
        instance.put(BASE_URL + 'admin/users/' + user_id, params).then((res) => {
            console.log("update", res)
            this.updateRolesList(user_id, obj.roleData);
            this.getUsers();
            this.closeDialog();
            this.showToast("Successfully modified", "success");
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delUsers(user_id, role_id) {
        instance.delete(BASE_URL + 'admin/user/' + user_id + '/roles/' + role_id).then((res) => {
            console.log("del", res)
            if (res.data.error === 0) {
                this.getUsers();
                this.showToast("Successfully deleted", "success");
            }
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    disabledUser(user_id, enabled) {
        console.log(user_id, enabled)
        const params = {
            enabled
        }
        instance.put(BASE_URL + 'admin/users/' + user_id, params).then((res) => {
            console.log(res)
            this.showToast("Successfully disabled", "success");
            this.getUsers();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    getAdminUsers(params) {
        //异步action
        instance.get(BASE_URL + 'admin/users', { params }).then((res) => {
            const users = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(users)
            this.setState(() => ({
                users,
                usersCopy: users,
                page_size,
                total_items
            }))
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    getOtherUsers(params) {
        console.log(params);
        //异步action
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            const users = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(users)
            this.setState(() => ({
                users,
                usersCopy: users,
                page_size,
                total_items
            }))
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }
    savePwd(user_id, password) {
        let params = {
            password,
        }
        instance.put(BASE_URL + 'admin/users/' + user_id, params).then((res) => {
            this.showToast("Password reset complete", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error")
        })
    }
}

export default withRouter(User);